import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import BeSafeTabTitle from 'components/commons/BeSafeTabTitle';

const BeSafeTabs = (props) => {
  // Controlled mode: when an `activeKey` prop is provided, the parent owns the
  // active tab and can gate switches (e.g. show a confirm-discard popup).
  // Otherwise behaves as before, tracking the active tab internally.
  const isControlled = props.activeKey !== undefined;
  const [internalKey, setInternalKey] = useState(props.defaultActiveKey);
  const key = isControlled ? props.activeKey : internalKey;

  useEffect(() => {
    if (!isControlled) setInternalKey(props.defaultActiveKey);
  }, [props.defaultActiveKey, isControlled]);

  const onSelectTab = (tab) => {
    if (!isControlled) setInternalKey(tab);
    props.onSelectTab(tab);
  };

  return (
    <Tabs
      defaultActiveKey={props.defaultActiveKey}
      id={props.id}
      activeKey={key}
      onSelect={(k) => onSelectTab(k)}
      className={`${props.className} thick-border-bottom mb-3 justify-content-start`}
      mountOnEnter={true}
      unmountOnExit={true}
    >
      {props.tabs.map((tab) => (
        <Tab
          key={tab.key}
          eventKey={tab.key}
          title={<BeSafeTabTitle icon={tab.icon} title={tab.title} />}
          className="content-small"
        >
          {tab.content}
        </Tab>
      ))}
    </Tabs>
  );
};

BeSafeTabs.defaultProps = {
  className: '',
  onSelectTab: () => {},
};

export default BeSafeTabs;
